import { render } from "./HistoryV310.vue?vue&type=template&id=06cdb0f4&scoped=true"
import script from "./HistoryV310.vue?vue&type=script&lang=js"
export * from "./HistoryV310.vue?vue&type=script&lang=js"

import "./HistoryV310.vue?vue&type=style&index=0&id=06cdb0f4&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06cdb0f4"]])

export default __exports__